import { render, staticRenderFns } from "./EstatePlanningPdfs.vue?vue&type=template&id=41774f8b"
import script from "./EstatePlanningPdfs.vue?vue&type=script&lang=js"
export * from "./EstatePlanningPdfs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports